const {isJustEat} = require('../config');

const routeNames = {
  home: 'home',
  personalArea: 'personalArea',
  restaurants: 'restaurants',
  restaurantsGroup: 'restaurantsGroup',
  city: 'city',
  menu: 'menu',
  shoppingCart: 'shoppingCart',
  checkout: 'checkout',
  orderSuccess: 'orderSuccess',
  cancelActiveOrder: 'cancelActiveOrder',
  info: 'info',
  sitemap: 'sitemap',
  signin: 'signin',
  updateUserDetails: 'updateUserDetails',
  linkMoneycard: 'linkMoneycard',
  coupons: 'coupons',
  accessibilityStatement: 'accessibilityStatement',
  otl: 'otl',
  payments: 'payments',
  errorPage: 'errorPage',
  reorder: 'reorder',
  chains: 'chains',
  orderSummary: 'order-summary',
  confirmAge: 'confirm-age',
  unsubscribe: 'unsubscribe',
  gfoOptOut: 'gfo-opt-out',
  join: 'join',
  gov: 'gov',
  tracker: 'tracker',
  shufersalVouchers: 'shufersal-vouchers',
  victoryVouchers: 'victory-vouchers',
};

const TENBIS_ONLY_INFO_PAGES_NAMES = [
  'add-company',
  'deals-policy',
  'deals-policy-iec',
  'over-the-limit-terms',
];

const InfoPagesNames = [
  'about-us',
  'privacy-policy',
  'report-a-bug',
  'terms-of-use',
  'report-vulnerability',
  ...isJustEat ? [] : TENBIS_ONLY_INFO_PAGES_NAMES,
];

const TENBIS_ONLY_ROUTES = [
  {
    name: routeNames.linkMoneycard,
    path: ['/link-moneycard-request'],
    hideFooter: true,
    disableEruptModals: true,
  },
  {
    name: routeNames.otl,
    path: ['/otl'],
    hideFooter: true,
  },
  {
    name: routeNames.gov,
    path: ['/gov'],
    disableEruptModals: true,
  },
  {
    name: routeNames.join,
    path: ['/join/:token?'],
    disableEruptModals: true,
  },
  {
    name: routeNames.shufersalVouchers,
    path: ['/shufersal-vouchers'],
    hideFooter: true,
  },
  {
    name: routeNames.victoryVouchers,
    path: ['/victory-vouchers'],
    hideFooter: true,
  },
  {
    name: routeNames.city,
    path: ['/משלוחים/:cityNameSlug?/:cuisineNameSlug?', '/deliveries/:cityNameSlug?/:cuisineNameSlug?'],
  },
];

const routes = [
  {
    name: routeNames.home,
    exact: true,
    path: ['/'],
  },
  {
    name: routeNames.personalArea,
    path: ['/personal-area'],
    hideFooter: true,
  },
  {
    name: routeNames.restaurantsGroup,
    path: ['/restaurants/group/:groupId/:name?'],
  },
  {
    name: routeNames.restaurants,
    exact: true,
    path: [
      // accept legacy urls with deliveryMethod and addressKey
      '/restaurants/:search(search)?/:deliveryMethod?/:addressKey?',
    ],
  },
  {
    name: routeNames.menu,
    path: ['/restaurants/menu/delivery/:restaurantId/:restaurantSlug/dish/:dishId/:shoppingCartDishId?'],
  },
  {
    name: routeNames.menu,
    path: [
      // accept legacy urls with deliveryMethod
      '/restaurants/menu/:deliveryMethod/:restaurantId/:restaurantSlug?',
    ],
  },
  {
    name: routeNames.shoppingCart,
    path: ['/shopping-cart'],
    hideFooter: true,
  },
  {
    name: routeNames.checkout,
    path: ['/checkout'],
    hideFooter: true,
  },
  {
    name: routeNames.orderSuccess,
    path: ['/order-success/:orderId'],
  },
  {
    name: routeNames.orderSummary,
    path: ['/order-summary/:orderId'],
    hideFooter: true,
  },
  {
    name: routeNames.cancelActiveOrder,
    path: ['/cancel-active-order'],
  },
  {
    name: routeNames.info,
    path: [`/:infoPageName(${InfoPagesNames.join('|')})`],
    hideFooter: true,
  },
  {
    name: routeNames.sitemap,
    path: ['/sitemap'],
  },
  {
    name: routeNames.signin,
    path: ['/signin'],
    hideFooter: true,
  },
  {
    name: routeNames.updateUserDetails,
    path: ['/update-user-details'],
    hideFooter: true,
    disableEruptModals: true,
  },
  {
    name: routeNames.coupons,
    path: ['/coupons/:restaurantId'],
    hideFooter: true,
  },
  {
    name: routeNames.accessibilityStatement,
    path: ['/accessibility-statement'],
  },
  {
    name: routeNames.payments,
    path: ['/payments'],
    hideFooter: true,
  },
  {
    name: routeNames.reorder,
    path: ['/reorder'],
  },
  {
    name: routeNames.chains,
    path: ['/chains'],
  },
  {
    name: routeNames.confirmAge,
    path: ['/confirm-age'],
    hideFooter: true,
  },
  {
    name: routeNames.unsubscribe,
    path: ['/unsubscribe/:unsubscribeToken'],
    hideFooter: true,
  },
  {
    name: routeNames.gfoOptOut,
    path: ['/gfo-opt-out'],
  },
  {
    name: routeNames.tracker,
    path: ['/tracker/:trackerToken'],
    hideFooter: true,
    disableEruptModals: true,
  },
  ...isJustEat ? [] : TENBIS_ONLY_ROUTES,
  {
    name: routeNames.errorPage,
    path: ['/*'],
  },
];

module.exports = {
  routes,
  routeNames,
  InfoPagesNames,
};
